import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearGroup } from "../../../Pages/Year group/IyearGroup";

export const DeleteyearGroupSlice = createSlice({
  name: "DeleteyearGroup",
  initialState: {} as IReduxState<IYearGroup>,
  reducers: {
    deleteyearGroup: (state, _) => {
      state.isLoading = true;
    },
    successdeleteyearGroup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteyearGroup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteyearGroupResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteyearGroup,
  failuredeleteyearGroup,
  successdeleteyearGroup,
  clearDeleteyearGroupResponse,
} = DeleteyearGroupSlice.actions;

export default DeleteyearGroupSlice.reducer;
